export default __webpack_public_path__ + "static/uniswap-white-46d2bc2a8633e640dbe52be74b34da2f.svg";